import { TwoFactorInitialSetupForm } from "@/components/Portal/UserAccount/Security/TwoFactorInitialSetupForm";

export const TwoFactorInitialSetupView = () => <TwoFactorInitialSetupForm />;
